module.exports = __webpack_public_path__ + "img/banker.d5cdb2cc.webp";